import React from "react";
import "./styles.scss";
import KC_Heading4 from "../typography/KC-Heading/KC_Heading4";
import KC_UIText from "../typography/KC_UIText/KC_UIText";
import { type GiftPerformance } from "../../app/04_Analytics/model/AnalyticsData";
import KC_Table from "../KC_Table/KC_Table";
import { tt } from "../../utils/i18n/i18n";
import KC_Text from "../typography/KC_Text/KC_Text";

interface Props {
  title: string;
  text?: string | number;
  giftsPerformance?: GiftPerformance[];
}

export default function KC_DashboardGiftsTable(props: Props) {
  return (
    <div className="d-flex flex-column kc-card-dashboard kc-card-dashboard-with-graph">
      <KC_Heading4 text={props.title} />
      {!!props.text && <KC_UIText weight="reg" text={props.text} />}
      <div className="d-flex flex-row ds-gap-column-standard flex-grow-1">
        <KC_Table
          border={true}
          keyPrefix="xx"
          headers={
            <tr>
              <th className={"text-center"}>
                <KC_Text size={"md"} weight={"bold"} text={tt("gift")} />
              </th>
              <th className={"text-center"}>
                <KC_Text size={"md"} weight={"bold"} text={tt("won")} />
              </th>
              <th className={"text-center"}>
                <KC_Text size={"md"} weight={"bold"} text={tt("redeemed")} />
              </th>
            </tr>
          }
        >
          {props.giftsPerformance?.map((datum) => {
            const pc = datum.nWon
              ? Math.trunc((datum.nRedeemed * 100) / datum.nWon)
              : 0;
            return (
              <tr>
                <td className={"text-center"}>
                  <KC_Text size="md" weight="reg" text={datum.name} />
                </td>
                <td className={"text-center"}>{datum.nWon}</td>
                <td className={"text-center"}>
                  {datum.nRedeemed}
                  {pc ? ` (${pc}%)` : ""}
                </td>
              </tr>
            );
          })}
        </KC_Table>
      </div>
    </div>
  );
}
